import CaptainAutonomyConfigAPI from 'dashboard/api/captain/autonomyConfig';

const state = {
  config: null,
  uiFlags: {
    fetching: false,
    updating: false,
    testingConnector: false,
  },
};

const getters = {
  getConfig: s => s.config,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_CONFIG(s, config) {
    s.config = config;
  },
  SET_UI_FLAG(s, flags) {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
};

const actions = {
  fetch: async ({ commit }, assistantId) => {
    commit('SET_UI_FLAG', { fetching: true });
    try {
      const response = await CaptainAutonomyConfigAPI.show(assistantId);
      commit('SET_CONFIG', response.data);
    } catch {
      // Config doesn't exist yet — that's OK
    } finally {
      commit('SET_UI_FLAG', { fetching: false });
    }
  },

  update: async ({ commit }, { assistantId, data }) => {
    commit('SET_UI_FLAG', { updating: true });
    try {
      const response = await CaptainAutonomyConfigAPI.update(assistantId, data);
      commit('SET_CONFIG', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { updating: false });
    }
  },

  updateToolRule: async ({ commit }, { assistantId, toolId, ruleData }) => {
    commit('SET_UI_FLAG', { updating: true });
    try {
      const response = await CaptainAutonomyConfigAPI.updateToolRule(
        assistantId,
        toolId,
        ruleData
      );
      commit('SET_CONFIG', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { updating: false });
    }
  },

  testDataConnector: async ({ commit }, { assistantId, ...connectorData }) => {
    commit('SET_UI_FLAG', { testingConnector: true });
    try {
      const response = await CaptainAutonomyConfigAPI.testDataConnector(
        assistantId,
        connectorData
      );
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { testingConnector: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
